/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
import { Button } from "@nextui-org/button";
import { useNavigate } from "react-router-dom";
import useTicketStore from "../../../stores/useTicketStore";
import AppUserProfile, { UserType } from "../../../assets/js/AppUserProfile";
import { Input } from "@nextui-org/input";
import OtherFilterDropDown from "./OtherFilter";
import { ReactComponent as Search } from "../../../assets/icons/search.svg";
import FilterSelector from "./FilterSelector";
import { ReactComponent as Rotate } from "../../../assets/icons/rotate.svg";
import { useQueryParams } from "../../../hooks/useQueryParams";
import Route from "../../../assets/js/Route";

function FilterBar({ isDisableStatus = false }) {
  const navigate = useNavigate();
  const user_role = AppUserProfile.getData()["whoami"];

  const {
    sortOptions,
    setSelectedStatus,
    setSelectedSort,
    selectedSort,
    setFindTicketId,
    selectedPhase,
    selectedStatus,
    getAvailableStatusOptions,
    initFilterByRole,
    allUniqueStatuses,
    resetFiltersKeepMenu,
    formatOtherFilterPayload,
    otherFilter,
    findTicketId,
  } = useTicketStore();

  const queryParams = useQueryParams();

  const availableStatuses = selectedPhase
    ? getAvailableStatusOptions()
    : allUniqueStatuses || [];

  const [ticketId, setTicketId] = useState("");
  const isInitialized = useRef(false);

  useEffect(() => {
    if (!user_role || isInitialized.current) return;

    initFilterByRole(user_role, queryParams);
    isInitialized.current = true;
  }, [user_role, queryParams]);

  useEffect(() => {
    if (isInitialized.current) {
      setTicketId(findTicketId ?? "");
    }
  }, [findTicketId]);

  const handleSortChange = (sort) => {
    setSelectedSort(sort, queryParams);
  };

  const handleFindTicketIdChange = (value) => {
    setTicketId(value);
  };

  const handleSearch = () => {
    setFindTicketId(
      ticketId && ticketId.length > 0 ? ticketId : null,
      queryParams
    );
  };

  const handleStatusChange = (status) => {
    setSelectedStatus(status, queryParams);
  };

  const handleResetAllFilters = () => {
    resetFiltersKeepMenu(queryParams);
    setTicketId("");
    formatOtherFilterPayload();
  };

  const hasActiveFilters = () => {
    const hasMainFilters =
      selectedStatus !== null ||
      (selectedSort && selectedSort.id !== sortOptions[0].id) ||
      ticketId.length > 0;

    const hasOtherFilters =
      otherFilter.dealerName.length > 0 ||
      otherFilter.dealerCode.length > 0 ||
      otherFilter.carModel.length > 0 ||
      otherFilter.activityType.length > 0 ||
      (otherFilter.activityPeriod.start && otherFilter.activityPeriod.end);

    return hasMainFilters || hasOtherFilters;
  };

  if (!isInitialized.current) {
    return (
      <div className="flex flex-col lg:flex-row w-full px-12 gap-4 items-center">
        <div className="w-full h-16 bg-gray-100 animate-pulse rounded"></div>
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-col lg:flex-row w-full px-12 gap-4 items-center">
        <div className="w-full">
          {user_role == UserType.DEALER_BYD ||
          user_role == UserType.DEALER_DENZA ? (
            <div className="flex justify-start items-center gap-3">
              <Button
                className="bg-black text-white w-full lg:w-fit"
                onPress={() => {
                  const currentParams = new URLSearchParams(
                    window.location.search
                  );
                  navigate(
                    `${Route.Ticket.Create}?${currentParams.toString()}`
                  );
                }}
              >
                + สร้างคำของบประมาณ
              </Button>
            </div>
          ) : (
            <></>
          )}
        </div>

        <div className="rounded-lg flex flex-col lg:flex-row gap-3 lg:justify-end w-full">
          <Input
            startContent={<div className="w-3 text-sm text-white" />}
            endContent={
              <div
                className="w-16 bg-black rounded-l-none h-full rounded-r-xl flex items-center justify-center cursor-pointer"
                onClick={handleSearch}
              >
                <Search width={17} className="text-white" />
              </div>
            }
            placeholder="เลขคำขอ"
            value={ticketId}
            classNames={{
              input: ["text-left", "bg-white"],
              inputWrapper: [
                "!bg-white",
                "p-0",
                "data-[hover=true]:bg-white bg-white",
                "data-[focus=true]:bg-white",
                "data-[focus-within=true]:bg-white",
                "transition-colors",
                "data-[invalid=true]:border-red-500",
                "group-data-[invalid=true]:border-red-500",
                "data-[invalid=true]:focus:border-red-500",
                "data-[invalid=true]:focus-within:border-red-500",
                "!border-1 !border-gray-300",
              ],
              label: ["data-[invalid=true]:text-red-500"],
              base: ["data-[disabled=true]:opacity-100"],
            }}
            className="min-w-60 max-w-full"
            onChange={(e) => {
              handleFindTicketIdChange(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
          />
          <FilterSelector
            id={"sort"}
            label={"จัดเรียง"}
            options={sortOptions}
            selectedValue={selectedSort}
            onChange={handleSortChange}
          />

          <FilterSelector
            id={"status"}
            label="สถานะ"
            options={availableStatuses}
            selectedValue={selectedStatus}
            onChange={handleStatusChange}
            isDisabled={isDisableStatus}
            isMultiSelect={false}
            showSelectAll={true}
            selectAllLabel="ทั้งหมด"
          />
          <OtherFilterDropDown />

          <Button
            className="bg-white text-black border border-gray-300 hover:bg-gray-100"
            isDisabled={!hasActiveFilters()}
            onPress={handleResetAllFilters}
          >
            {
              <div className="flex gap-x-2 items-center">
                <Rotate width={15} />
                <p>ล้างค่า</p>
              </div>
            }
          </Button>
        </div>
      </div>
    </>
  );
}

export default FilterBar;
